module.exports = __webpack_public_path__ + "img/ai-text.3c5cf1b0.svg";